/**
 * 内部收款单列表页面路径
 */
export const INTERNAL_COLLECTION_LIST_PAGE_PATH = '/internalCollection/list'
